<template>
  <transition :name="transitionName" mode="out-in">
    <div id="box_wrap" class="box_wrap" v-if="boxShow" @click="handleEvent($event)">
        <div class="box_content">
            <div class="close xb-bg" @click="handleEvent($event)"></div>
            <slot></slot>
        </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "box",
  data() {
    return {
      transitionName: "", //判断ie和在chore下的过渡动画
    };
  },
  props:{
      boxShow:{
          type:Boolean,
          default:true,
      }
  },
  created() {
    this.isIe();
  },
  methods: {
    isIe() {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        this.transitionName = "";
      } else {
        this.transitionName = "box";
      }
    },
    handleEvent(e){
        if(e.target.className === "box_wrap" || e.target.className === "close xb-bg"){
            this.emitFn();
        } else {
            e.cancelBubble = true;
            return false;
        }
    },
    emitFn(){
        this.$emit('close', false)
    }
  }
};
</script>
<style lang="scss" scoped>
.box-enter-active,
.box-leave-active {
//   margin-top: 0;
  transition: all ease-out 0.3s;
}
.box-enter,
.box-leave-to {
//   margin-top: -100%;
    opacity:0;
}
#box_wrap {
  background: rgba($color: #000000, $alpha: 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1100;
  .box_content{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: url('../../assets/images/box.png') no-repeat top center/608px 320px;
      height: 320px;
      width: 608px;
      .close{
          width: 37px; height: 30px;
          background-position: -436px -190px;
          position: absolute;
          right: 20px;
          top: 8px;
          cursor: pointer;
      }
  }
}
</style>